import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'showIcon', 'hideIcon']

  toggle () {
    const revealed = this.inputTarget.type === 'text'
    this.inputTarget.type = revealed ? 'password' : 'text'
    this.showIconTarget.classList.toggle('hidden', !revealed)
    this.hideIconTarget.classList.toggle('hidden', revealed)

    const label = revealed ? 'Show password' : 'Hide password'
    if (this.hasButton) this.button.setAttribute('aria-label', label)
  }

  get button () {
    return this.element.querySelector('[data-action~="password-toggle#toggle"]')
  }

  get hasButton () {
    return Boolean(this.button)
  }
}
